import React, { useState } from 'react'
import { Button, TextField } from '@mui/material'

const VoucherApprovalsTable = ({ voucher, onApprove }: any) => {
  const [comments, setComments] = useState<{ [approvalId: string]: string }>({})

  const handleCommentChange = (approvalId: string, value: string) => {
    setComments((prev) => ({
      ...prev,
      [approvalId]: value,
    }))
  }

  const approvals = [...voucher.voucher_approvals].sort(
    (a, b) => a.order_number - b.order_number
  )

  return (
    <div style={{ padding: '1rem' }}>
      <h4>Approval Stages</h4>
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Stage</th>
            <th>Approver</th>
            <th>Status</th>
            <th>Comment</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {approvals.map((a: any) => (
            <tr key={a.id}>
              <td>{a.approver.user_role.name}</td>
              <td>{a.approver.email}</td>
              <td>{a.status}</td>
              <td>{a.comment || '-'}</td>
              <td>
                {a.status === 'PENDING' && (
                  <>
                    <TextField
                      size="small"
                      placeholder="Comment"
                      value={comments[a.id] || ''}
                      onChange={(e) =>
                        handleCommentChange(a.id, e.target.value)
                      }
                    />
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() =>
                        onApprove(
                          voucher.id,
                          a.approval_stage.id,
                          comments[a.id] || '',
                          a.approval_stage.is_payment_stage
                        )
                      }
                    >
                      {a.approval_stage.is_payment_stage
                        ? 'Mark as Paid'
                        : 'Approve'}
                    </Button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default VoucherApprovalsTable
